// Weekly loan payment for every active loan.
// Outstanding loans accrue interest at ratePerWeek; principal portion of the
// fixed weekly payment retires debt. Once remainingPrincipal == 0, no more payments.

import type { GameState, LoanInstance } from '../state/types.js';
import { applyTxn } from '../ledger/append.js';
import { applyOnePayment } from './amortise.js';

export function settleLoanPayments(state: GameState): GameState {
  let s = state;
  const updatedLoans: LoanInstance[] = [];

  for (const loan of state.loans) {
    if (loan.remainingPrincipal <= 0) {
      updatedLoans.push(loan);
      continue;
    }
    const breakdown = applyOnePayment(
      loan.remainingPrincipal,
      loan.ratePerWeek,
      loan.weeklyPayment,
    );
    s = applyTxn(s, {
      type: 'loan_payment',
      amount: -breakdown.payment,
      category: 'debt',
      note: `Loan ${loan.id} payment (#${loan.paymentsMade + 1}/${loan.termWeeks})`,
    });
    updatedLoans.push({
      ...loan,
      paymentsMade: loan.paymentsMade + 1,
      remainingPrincipal: breakdown.remainingPrincipal,
    });
  }

  return { ...s, loans: updatedLoans };
}
